var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',[_c('h5',[_vm._v("JOB Logs")])]),_c('b-card-body',[_c('app-tabela',{attrs:{"idTabela":"tblJobLogs","itens":_vm.jobLogs,"campos":_vm.campos,"itensPorPagina":_vm.itensPorPagina}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }